import lodash from 'lodash'
import Base from '../base.store'
import request from "../../../../utils/request";

const baseUrl = '/api/v1/master/attachments'
const base = new Base(baseUrl)
const criteriaIgnore = ['totalPage', 'totalSize', 'data']

export default {
    namespaced: true,
    state: lodash.merge(lodash.cloneDeep(base.state), {}),
    getters: {
        ...base.getters
    },
    actions: {
        ...base.actions,
        searchByModelAndRefId(context, { criteria, config }) {
            criteria = lodash.cloneDeepWith(criteria, (value, key) => {
                if (criteriaIgnore.includes(key)) {
                    return null
                }
            })
            return request.post(`${baseUrl}/search/model-id`, criteria, { ...config })
        },
    },
    mutations: {
        ...base.mutations
    },
}
